import client from "./client.js";

export async function fetchSites() {
  const res = await client.get("/sites");
  return res.data.data;
}

export async function fetchSite(id) {
  const res = await client.get(`/sites/${id}`);
  return res.data.data;
}

export async function fetchSiteDashboard(id) {
  const res = await client.get(`/sites/${id}/dashboard`);
  return res.data.data;
}

export async function quickSetup(payload) {
  const res = await client.post("/sites/quick-setup", payload);
  return res.data.data;
}

export async function deleteSite(id) {
  const res = await client.delete(`/sites/${id}`);
  return res.data.data;
}
